import { get } from '../Services/http';
import { catchError } from './Error.action';

export const PRODUCT_CONFIGURATOR_LOAD = 'PRODUCT_CONFIGURATOR_LOAD';
export const PRODUCT_CONFIGURATOR_LOAD_ERROR =
  'PRODUCT_CONFIGURATOR_LOAD_ERROR';
export const PRODUCT_CONFIGURATOR_RECEIVE = 'PRODUCT_CONFIGURATOR_RECEIVE';

export const load = (baseProductId) => (dispatch, getState) => {
  var url = '/api/productConfiguration/forBaseProduct';
  url += '?baseProductId=' + encodeURIComponent(baseProductId);
  return get(url)
    .then((response) => {
      return response.json();
    })
    .then((data) => dispatch(receive(data)))
    .catch((ex) => dispatch(catchError(ex, (error) => loadError(error))));
};

export const loadError = (error) => ({
  type: PRODUCT_CONFIGURATOR_LOAD_ERROR,
  payload: {
    error,
  },
});

export const receive = (data) => {
  return {
    type: PRODUCT_CONFIGURATOR_RECEIVE,
    payload: {
      articles: data.configurationSection,
      emptyArticles: data.emptyConfigurationSection,
    },
  };
};

export const increment = (articleId) => (dispatch, getState) => {
  var articles = getState().articles.articles.slice();
  var emptyArticles = getState().articles.emptyArticles.slice();
  articles.find((elem) => elem.defaultVariant == articleId).defaultAmmount++;
  return dispatch(
    receive({
      configurationSection: articles,
      emptyConfigurationSection: emptyArticles,
    })
  );
};

export const decrement = (articleId) => (dispatch, getState) => {
  var articles = getState().articles.articles.slice();
  var emptyArticles = getState().articles.emptyArticles.slice();
  if (
    articles.find((elem) => elem.defaultVariant == articleId).defaultAmmount > 0
  ) {
    articles.find((elem) => elem.defaultVariant == articleId).defaultAmmount--;
  }
  return dispatch(
    receive({
      configurationSection: articles,
      emptyConfigurationSection: emptyArticles,
    })
  );
};

export const changeVariant = (oldId, newId) => (dispatch, getState) => {
  var articles = getState().articles.articles.slice();
  var emptyArticles = getState().articles.emptyArticles.slice();
  articles.find((elem) => elem.defaultVariant == oldId).defaultVariant = newId;
  return dispatch(
    receive({
      configurationSection: articles,
      emptyConfigurationSection: emptyArticles,
    })
  );
};

export const changeActiveArticle = (articleName) => (dispatch, getState) => {
  var articles = getState().articles.articles.slice();
  var emptyArticles = getState().articles.emptyArticles.slice();
  var article = articles.find((elem) => elem.name == articleName);
  if (article.active === undefined) {
    article.active = false;
  } else {
    article.active = !article.active;
  }
  return dispatch(
    receive({
      configurationSection: articles,
      emptyConfigurationSection: emptyArticles,
    })
  );
};
